import { Button } from '@/components/ui/button'

interface Props {
  clientLabel: string
  sourceChanged: boolean
  onReset: () => void
  onDismiss: () => void
}

export function SourceStaleBanner({ clientLabel, sourceChanged, onReset, onDismiss }: Props) {
  if (!sourceChanged) return null
  return (
    <div className="flex items-center justify-between rounded-md border border-amber-200 bg-amber-50 px-3 py-2 mb-3 text-sm text-amber-900">
      <span>{clientLabel}'s dossier has changed since this draft.</span>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" onClick={onReset}>
          Reset to refresh
        </Button>
        <Button variant="ghost" size="sm" onClick={onDismiss}>
          Keep my edits
        </Button>
      </div>
    </div>
  )
}
